import { Alert } from '@cmsgov/ds-medicare-gov';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import TranslatedSpan from '../../common/components/TranslatedSpan';
import translate from '../../common/functions/translate';

interface AccountUpdatedProps {
    resetLoginFlow: () => void
}

export default function AccountUpdated(props: AccountUpdatedProps) {
    return <>
        <Div
            isContainer={true}
            paddingySM={1}
            paddingyMD={2}
            paddingyLG={3}
            paddingyXL={4}>

            <Div isRow>
                <Div cols={12} marginBottom={3}>
                    <H1>
                        <TranslatedSpan english={'your_account_updated'}/>
                    </H1>
                </Div>
            </Div>

            <Div isRow>
                <Div cols={12} colsMD={8}>
                    <Alert heading={translate('you_all_set')}
                        variation="success"
                        hideIcon={true}>
                        <p className="ds-c-alert__text">
                            <TranslatedSpan english={'you_can_start_account'}/>
                        </p>
                    </Alert>
                </Div>
            </Div>

            <Div
                isRow={true}
                paddingBottom={3}
                paddingTop={3}
            >
                <Div cols={5} colsSM={5} colsMD={4} colsLG={3} colsXL={3}>
                    <Button
                        variation={'solid'}
                        mfaAnalyticsData={{
                            text: translate('go_to_account'),
                            parentComponentHeading: translate('update_account')
                        }}
                        onClick={() => props.resetLoginFlow() }
                    >
                        <TranslatedSpan english={'go_to_account'}/>
                    </Button>
                </Div>
            </Div>
        </Div>
    </>
}
